import PropTypes from 'prop-types';

import { isDesktopEnvironment } from 'utils/helper';

const MobileOnly = ({ children }) => {
  if (isDesktopEnvironment()) return null;
  return children;
};

MobileOnly.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MobileOnly;
